import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

const AttendanceRateChart = ({ data, chartData = [] }) => {
    const {
        attendanceRate = 0,
    } = data || {};

    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Pega o maior rate para definir a escala (sempre 100% como teto para taxa)
    const maxRate = 100;

    const currentRateColor = "#e2661c"; // Laranja ativo

    return (
        <Card 
            className="neo-stat-card h-100" 
            style={{ 
                borderRadius: "16px", 
                border: "2px solid #482712", 
                boxShadow: "0 15px 40px rgba(72, 39, 18, 0.08)",
                background: "#fff",
                fontFamily: "'Outfit', 'Inter', sans-serif"
            }}
        >
            <CardHeader className="neo-chart-card-header">
                <div className="neo-chart-header-container">
                    <div className="d-flex align-items-center gap-2">
                        <div
                            style={{ 
                                width: "38px", 
                                height: "38px", 
                                minWidth: "38px",
                                borderRadius: "10px",
                                background: "rgba(226, 102, 28, 0.08)",
                                border: "1px solid rgba(226, 102, 28, 0.20)",
                                color: "#e2661c",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <i className="mdi mdi-calendar-check font-size-18"></i>
                        </div>
                        <h5 className="neo-chart-title">
                            Taxa de Comparecimento
                        </h5>
                    </div>
                    <div className="neo-chart-legend-container">
                        <div className="d-flex align-items-center">
                            <span className="rounded-circle" style={{ width: "8px", height: "8px", backgroundColor: "#ebdcc5", marginRight: "6px" }} />
                            <small style={{ color: "#784b22", fontWeight: "800", fontSize: "0.72rem" }}>{previousYear}</small>
                        </div>
                        <div className="d-flex align-items-center ms-2">
                            <span className="rounded-circle" style={{ width: "8px", height: "8px", backgroundColor: "#482712", marginRight: "6px" }} />
                            <small style={{ color: "#784b22", fontWeight: "800", fontSize: "0.72rem" }}>{currentYear}</small>
                        </div>
                        <div className="text-end ms-2">
                            <small className="text-muted d-block fw-bold font-size-10 text-uppercase">Atual</small>
                            <span className="fw-bold font-size-15" style={{ color: currentRateColor }}>
                                {attendanceRate}%
                            </span>
                        </div>
                    </div>
                </div>
            </CardHeader>

            <CardBody className="p-4 mt-2">
                <div style={{ overflowX: "auto", overflowY: "hidden", paddingBottom: "10px" }} className="custom-scroll">
                    <div style={{ height: "260px", display: "flex", alignItems: "flex-end" }}>
                        <div style={{ height: "200px", position: "relative", paddingLeft: "45px", paddingRight: "15px", minWidth: "550px", width: "100%" }}>
                        {/* Eixo Y (%) */}
                        <div 
                            style={{ 
                                position: "absolute", 
                                left: -10, 
                                height: "100%", 
                                display: "flex", 
                                flexDirection: "column", 
                                justifyContent: "space-between", 
                                fontSize: "0.72rem", 
                                color: "#784b22", 
                                fontWeight: "800", 
                                paddingBottom: "35px",
                                width: "30px",
                                textAlign: "right"
                            }}
                        >
                            <span>100%</span>
                            <span>75%</span>
                            <span>50%</span>
                            <span>25%</span>
                            <span>0%</span>
                        </div>

                        {/* Linhas de Grade */}
                        <div style={{ position: "absolute", top: 0, left: "45px", right: "15px", bottom: "35px", display: "flex", flexDirection: "column", justifyContent: "space-between", zIndex: 0 }}>
                            {[0, 1, 2, 3, 4].map(i => <div key={i} style={{ borderBottom: "1px dashed rgba(72, 39, 18, 0.12)", width: "100%", height: "1px" }} />)}
                        </div>

                        {/* Linha de meta 90% */}
                        <div style={{
                            position: "absolute",
                            left: "45px",
                            right: "15px",
                            bottom: `calc(${(90 / maxRate) * 100}% * (1 - 35px / 100%) + 35px)`,
                            borderBottom: "2px dashed #e2661c",
                            opacity: 0.5,
                            zIndex: 0,
                        }}>
                            <span style={{ position: "absolute", right: 0, top: -16, fontSize: "9px", color: "#e2661c", fontWeight: "900" }}>META 90%</span>
                        </div>

                        {/* Barras */}
                        <div className="h-100 w-100 d-flex position-relative align-items-end" style={{ zIndex: 1, paddingBottom: "35px" }}>
                            {chartData.map((item, idx) => {
                                const prevHeight = (item.prevRate / maxRate) * 100;
                                const currentHeight = (item.currentRate / maxRate) * 100;
                                const isCurrentMonth = idx === new Date().getMonth();

                                return (
                                    <div key={idx} className="flex-grow-1 h-100 d-flex flex-column align-items-center position-relative">
                                        <div className="d-flex justify-content-center align-items-end h-100 w-100 gap-1"
                                             style={{ cursor: "pointer" }}
                                             title={`${item.month}: ${item.currentRate}% (${item.present}/${item.enrolled}) | ${previousYear}: ${item.prevRate}%`}>

                                            {/* Barra Ano Anterior (Cinza outonal) */}
                                            <div
                                                style={{
                                                    width: "12px",
                                                    height: `${prevHeight}%`,
                                                    backgroundColor: "#ebdcc5",
                                                    border: "1px solid rgba(72, 39, 18, 0.15)",
                                                    borderRadius: "4px 4px 0 0",
                                                    transition: "height 0.8s ease-in-out",
                                                    opacity: 0.8,
                                                    minHeight: item.prevRate > 0 ? "4px" : "0"
                                                }}
                                            />

                                            {/* Barra Ano Atual */}
                                            <div
                                                style={{
                                                    width: "12px",
                                                    height: `${currentHeight}%`,
                                                    backgroundColor: "#482712",
                                                    border: "1px solid #482712",
                                                    borderRadius: "4px 4px 0 0",
                                                    transition: "height 0.8s ease-in-out",
                                                    opacity: isCurrentMonth ? 1 : 0.85,
                                                    minHeight: item.currentRate > 0 ? "4px" : "0"
                                                }}
                                            />
                                        </div>

                                        {/* Badge % Acima da Barra */}
                                        {item.currentRate > 0 && (
                                            <span
                                                className="position-absolute"
                                                style={{
                                                    bottom: `calc(${Math.max(currentHeight, prevHeight)}% + 35px)`,
                                                    fontSize: "9px",
                                                    fontWeight: "bold",
                                                    color: isCurrentMonth ? "#e2661c" : "#482712",
                                                    opacity: isCurrentMonth ? 1 : 0.7
                                                }}
                                            >
                                                {item.currentRate}%
                                            </span>
                                        )}

                                        {/* Mês Label */}
                                        <span
                                            className="position-absolute text-center"
                                            style={{
                                                bottom: "-25px",
                                                fontSize: "10px",
                                                fontWeight: isCurrentMonth ? "900" : "800",
                                                color: isCurrentMonth ? "#e2661c" : "#482712"
                                            }}
                                        >
                                            {item.month}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            </CardBody>
        </Card>
    );
};

export default AttendanceRateChart;
